import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { createFileRoute } from '@tanstack/react-router';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/library')({
    component: Library,
});

function Library() {
    const claim = claimFormStore.use.formData();
    // CUR-725: closed claims are read-only — uploads and file edits are withheld.
    const isReadonly = claimFormStore.use.isReadonly();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="claim"
                entityId={claim.id}
                disableUploading={isReadonly}
                readOnly={isReadonly}
                showDownloadAllButton
                fileNamePrefix={`${claim.generatedId || claim.id}`}
                shouldIncludeRelatedEntities
            />
        </PageController>
    );
}
